/**
 * `router/infographic.js`
 *  - infographicページ用スクリプト
 *
 * 使用方法:
 *  - /router/index.js initRouterで動的読み込み
 *  - import {infographicRouter} from "./router/infographic.js";
 */


export const infographicRouter = () => {

  console.log("📖 Initializing infographic page...");

  const counters = document.querySelectorAll('[data-animation-trigger="countup"]');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counterEls = entry.target.querySelectorAll('[data-animation-content="countup"]');
        counterEls.forEach(counterEl => {
          if (!counterEl || counterEl.dataset.animated) return;

          countUp(counterEl);
          counterEl.dataset.animated = "true";
        });
      }
    });
  }, {
    threshold: 0.6, // 60% 見えたらトリガー
  });

  counters.forEach(el => observer.observe(el));

  function countUp(el) {
    const target = parseInt(el.textContent, 10);
    const duration = 1500; // ms
    const frameRate = 60;
    const totalFrames = Math.round(duration / (1000 / frameRate));
    let frame = 0;

    const counter = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;
      const current = Math.round(target * easeOutQuad(progress));
      // If the element has data-no-grouping="true", do not insert commas
      if (el.dataset.noGrouping === "true") {
        el.textContent = current.toString();
      } else {
        el.textContent = current.toLocaleString();
      }

      if (frame === totalFrames) clearInterval(counter);
    }, 1000 / frameRate);
  }

  function easeOutQuad(t) {
    return t * (2 - t);
  }
}